import { render, staticRenderFns } from "./exchange-query.vue?vue&type=template&id=5612522b&scoped=true&"
import script from "./exchange-query.vue?vue&type=script&lang=js&"
export * from "./exchange-query.vue?vue&type=script&lang=js&"
import style0 from "./exchange-query.vue?vue&type=style&index=0&id=5612522b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5612522b",
  null
  
)

export default component.exports